// extracted by mini-css-extract-plugin
module.exports = {"paper":"ShelterDescription_paper__SCBn0"};